import { useEffect, useRef } from "react";
import { useNavbar } from "../context/NavbarContext";
import Accordion from "./Accordion";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { MENU_SECTION_ENUM } from "../utils/enums";

export default function Consider() {
  const { setActiveSection } = useNavbar();
  const sectionRef = useRef(null);
  const sectionObserver = useIntersectionObserver(sectionRef);

  useEffect(() => {
    if (sectionObserver?.isIntersecting) {
      setActiveSection(MENU_SECTION_ENUM.CONSIDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionObserver]);

  return (
    <section className="xpb-consider" id="xpb-consider" ref={sectionRef}>
      <div className="xpb-consider__title">
        <h3>
          A tener <br />
          en cuenta
        </h3>
        <h4>
          7 puntos que hay que tener en cuenta al momento de hablar de personas
          migrantes
        </h4>
      </div>
      <div className="xpb-consider__accordion-container">
        <Accordion
          title={
            <h5>
              <span>1· El lenguaje</span> construye realidad
            </h5>
          }
          content={
            <>
              <p>
                Para cambiar la percepción sobre las personas migrantes y
                refugiadas es necesario usar las palabras adecuadas.
              </p>
              <p>
                No es lo mismo hablar de personas migrantes en situación
                irregular, que de ilegales.
              </p>
              <a href="/xenophobia/BID_Glosario.pdf" download>
                Descarga el glosario de conceptos y palabras clave.
              </a>
            </>
          }
        />
        <Accordion
          title={
            <h5>
              <span>2·</span> Las personas migrantes{" "}
              <span>no están de paso</span>
            </h5>
          }
          content={
            <p>
              La mayoría de las personas migrantes y refugiadas planean quedarse
              donde están a largo plazo. Las estrategias de comunicación deben
              desafiar la percepción de estas personas como transitorias o
              “invitadas" temporales. Es importante destacar su papel como
              miembros de la sociedad receptora.
            </p>
          }
        />
        <Accordion
          title={
            <h5>
              <span>3·</span> Los datos tienen que estar{" "}
              <span>respaldados por una historia</span>
            </h5>
          }
          content={
            <p>
              Un dato por sí solo no es suficiente para desmentir un prejuicio.
              Los datos son útiles cuando hacen referencia a historias reales.
              Es conveniente vincular los datos e información a una narrativa
              que favorezca su interpretación y asimilación.
            </p>
          }
        />
        <Accordion
          title={
            <h5>
              <span>4· Humanizar</span> la migración
            </h5>
          }
          content={
            <>
              <p>
                Los flujos migratorios son mucho más que un fenómeno
                demográfico. Es necesario dar rostros y relatos a los números;
                mostrar las historias individuales de las personas migrantes y
                refugiadas para fomentar la empatía con la sociedad receptora.
              </p>
              <p>
                Darle voz a personas migrantes y refugiadas en las piezas
                comunicacionales las coloca como sujetos de derechos activos
                respecto a su integración.
              </p>
            </>
          }
        />
        <Accordion
          title={
            <h5>
              <span>5· Mostrar la diversidad</span> de la migración como es
            </h5>
          }
          content={
            <p>
              Las historias deben reflejar la variedad de perfiles que existen
              entre las personas migrantes y refugiadas y la comunidad. Dar
              visibilidad a distintos grupos etarios, a la diversidad de
              géneros, composiciones familiares, niveles socioeconómicos y
              educativos amplía la mirada sobre la movilidad humana y aumenta
              las oportunidades de que las personas que reciben el mensaje se
              sientan interpeladas con la situación de la persona migrante que
              se aleja del estereotipo.
            </p>
          }
        />
        <Accordion
          title={
            <h5>
              <span>6· Contar historias</span> con personas y lugares reales
            </h5>
          }
          content={
            <>
              <p>
                Es necesario evitar el uso de mensajes publicitarios: los
                mensajes muy elaborados estéticamente o curados no son genuinos,
                lo que resta credibilidad y capacidad de conexión con la
                audiencia.
              </p>
              <p>
                El impacto depende de una buena historia. La credibilidad y la
                confianza se ganan mostrando lo auténtico. Es más valorado un
                buen guion, que una producción costosa.
              </p>
            </>
          }
        />
        <Accordion
          title={
            <h5>
              <span>7· Incorporar</span> a la población local
            </h5>
          }
          content={
            <p>
              Incluir a la población local nutre de realismo a las historias y
              transmite los procesos de integración cotidianos en la comunidad
              receptora.
            </p>
          }
        />
      </div>
    </section>
  );
}
